import { Minter } from "@components/Minter";

export const HomePage = () => {
  return <Minter />;
};

export default HomePage;
